import type { Rule } from "antd/lib/form";
import i18n from "i18next";

import type { ValidationRuleParams } from "../../../types/types";

export const getMaxLengthRule = (validationRuleParams: ValidationRuleParams) => {
    if (!validationRuleParams || validationRuleParams.length === 0) {
        return undefined;
    }

    const MAX_LENGTH_ARG = 0;

    return {
        validator: (_, value) => {
            if (!value) {
                return Promise.resolve();
            }

            if (`${value}`.length <= Number(validationRuleParams[MAX_LENGTH_ARG])) {
                return Promise.resolve();
            }

            return Promise.reject(i18n.t("common.input.maxCharacters.error", { max: validationRuleParams[MAX_LENGTH_ARG] }));
        },
    } as Rule;
};
